(ns manage.ad-variant-preview.db
  (:require [clojure.set :as set]
            [manage.ad-variant-preview.data :as data]
            [re-frame.core :as rf]))

(rf/reg-event-fx ::open-preview
  (fn [{:keys [db]} [_ selected-ad-variant-revision-uuids review?]]
    {:db (assoc-in db [::state :visible] selected-ad-variant-revision-uuids)
     :fx [[:dispatch [::init-page]]
          [:router/update-query #(assoc %
                                        :ad-variants-preview true
                                        :review review?)]]}))

;; Store the selected variants to Re-frame because
;; hook state isn't kept over reloads.
(rf/reg-sub ::visible
  (fn [db _]
    (:visible (::state db))))

(defn- symmetric-difference [a b]
  (set/union (set/difference a b) (set/difference b a)))

(set/difference #{1 5} #{1 3 4})

(rf/reg-event-db ::toggle-visible
  (fn [db [_ uuids]]
    (update-in db [::state :visible] (fnil symmetric-difference #{}) uuids)))

(rf/reg-event-db ::set-visible
  (fn [db [_ uuids]]
    (assoc-in db [::state :visible] (set uuids))))

(rf/reg-event-db ::set-visible-item
  (fn [db [_ uuid]]
    (assoc-in db [::state :visible] #{uuid})))

(rf/reg-sub ::pos
  (fn [db _]
    (:pos (::state db))))

(rf/reg-sub ::mode
  (fn [db _]
    (:mode (::state db))))

(rf/reg-sub ::no-user-access-warning-shown
  (fn [db _]
    (get-in db [::no-user-access-warning-shown])))

(rf/reg-event-db ::no-user-access-warning-shown
  (fn [db _]
    (assoc-in db [::no-user-access-warning-shown] true)))

(rf/reg-sub ::new-comment
  (fn [db _]
    (or (:new-comment (::state db))
        {})))

(rf/reg-event-db ::set-new-comment-info
  (fn [db [_ v]]
    (-> db
        (assoc-in [::state :products-open] false)
        (assoc-in [::state :comments-open] true)
        (update-in [::state :new-comment] (fn [x]
                                            (-> x
                                                (dissoc :props :info)
                                                (merge v)))))))

(rf/reg-event-db ::set-new-comment-value
  (fn [db [_ value]]
    (assoc-in db [::state :new-comment :value] value)))

(rf/reg-event-db ::cancel-new-comment
  (fn [db [_]]
    (update db ::state dissoc :new-comment)))

;; This is best or only way to now trigger side effects
;; ON NAVIGATION. Hooks don't quite work as they
;; are retriggered on shadow-cljs reloads.
(rf/reg-event-db ::init-page
  (fn [db _]
    ;; When preview page is opened, forget expanded status, filters, selected items etc.
    ;; NOTE: If we want to keep previous state when the adset-id or share-link-id
    ;; stays the same, we could check the previous key.
    ;; Visible variants is set up by the open link, based on variants table selections.
    (-> db
        (update ::state select-keys [:visible])
        (assoc-in [::state :comments-open] false)
        (assoc-in [::state :products-open] false))))

(comment
  (rf/reg-sub ::filters
    (fn [app-db _]
      (merge (assoc data/empty-filters :search "")
             (get-in app-db [::state :filters]))))

  (rf/reg-sub ::visible-selection
    (fn [app-db _]
      (get-in app-db [::state :visible])))

  (rf/reg-sub ::filtered-variants
    (fn [[_ ad-variants-sub]]
      [(rf/subscribe ad-variants-sub)
       (rf/subscribe [::filters])])
    (fn [[ad-variants filters] _]
      (js/console.log "calculate filtered-variants")
      (data/get-filtered-variants ad-variants filters)))

  ;; Take ad-variants sub as input, because it is different for regular and shared page
  (rf/reg-sub ::visible-variants
    (fn [[_ ad-variants-sub]]
      [(rf/subscribe [::filtered-variants ad-variants-sub])
       (rf/subscribe [::visible-selection])])
    (fn [[filtered-variants visible-selection] _]
      (js/console.log "calculate visible-variants")
      (data/get-selected-variants filtered-variants visible-selection))))
